export function nullToUndefined<T>(value: T | null): T | undefined {
  if (value !== null) {
    return value;
  }

  return undefined;
}
